import React, { useState } from 'react';
import { Box, Button, Container, Image, SimpleGrid, Text, useColorModeValue } from '@chakra-ui/react';
import { motion } from 'framer-motion';

import elegant2 from '../vatars/elegant2.png';
import you1 from '../vatars/youtube1.png';
import you2 from '../vatars/youtube2.png';
import weath from '../vatars/weatherimg1.png';
import weath2 from '../vatars/weatherimg2.png';
import click from '../vatars/clickimg1.png';
import click2 from '../vatars/clickimg2.png';
import click3 from '../vatars/clickimg3.png';
import elegant from '../vatars/elegant.png';
import { SiCss3, SiHtml5, SiJavascript, SiReact, SiRedux } from 'react-icons/si';

const projects = [
  {
    techStack: ['Reactjs', 'Chakra-ui', 'Expressjs'],
    src: elegant,
    altSrc: elegant2,
    name: 'Elegant',
    disc:
      'Elegant, which sells apparel and mobile phone covers, is better known for creating head-turning custom catalogs',
    netlify: 'https://itchy-nation-5605.vercel.app/',
    github: 'https://github.com/arupadhyay25/Elegant',
  },
  {
    techStack: ['Reactjs', 'ChakraUi', 'Expressjs',`Nodemailer`],
    src: click,
    altSrc: click2,
    name: 'Click',
    disc:
      'Click is a social media web application where you can show your photography skills.More updates are comming..',
    netlify: 'https://click-beta.vercel.app/',
    github: 'https://github.com/Rohit20033/frontBudd',
  },
  {
    techStack: ['Reactjs', 'Chakra-ui', 'JavaScript'],
    src: weath,
    altSrc: weath2,
    name: 'Weather-App',
    disc:
      'Weather-App is a simple weather application built with React and Chakra UI. It allows you to check the weather forecast for different locations.',
    netlify: 'https://weather-app-gules-omega-83.vercel.app/',
    github: 'https://github.com/Rohit20033/WeatherApp',
  },
  {
    techStack: ['Reactjs', 'Chakra-ui', 'JavaScript'],
    src: you1,
    altSrc: you2,
    name: 'Youtube',
    disc:
      'It is a youtube clone where you can search any youtube content and watch',
    netlify: 'https://youtube-ten-phi.vercel.app/',
    github: 'https://github.com/Rohit20033/Youtube',
  },
];

function ProjectsP() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <>
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: '100%' }}
        exit={{ x: window.innerWidth, transition: { duration: 0.4 } }}
        p={8}
        bgGradient="linear(to-r, teal.400, blue.500)"
        color="white"
      >
        <Box textAlign="center" mb={8}>
          <Text
            as="h1"
            fontSize={['28px', '32px', '36px', '40px']}
            fontWeight="bold"
            textShadow="0 0 10px black"
          >
            Projects
          </Text>
        </Box>
        <SimpleGrid columns={[1, 1, 1, 1]} spacing={8} width="90%" margin="auto" marginTop="20px">
          {projects.map((item, index) => {
            return (
              <Box
                key={item.name}
                borderRadius="10px"
                height="auto"
                boxShadow="0 0 15px 2px black"
                _hover={{
                  cursor: 'pointer',
                  transform: hoveredIndex === index ? 'scale(1.05)' : 'scale(1)',
                  transition: 'transform 0.3s ease-in-out',
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                overflow="hidden"
              >
                <SimpleGrid columns={[1, 1, 1, 2]} paddingBottom="20px">
                  <Box margin="auto" width={['100%', '100%', '90%']}>
                    <Image
                      height="100%"
                      width="100%"
                      src={hoveredIndex === index ? item.altSrc : item.src}
                      alt={item.name}
                    />
                  </Box>
                  <Box padding="20px">
                    <Box>
                      <Text
                        textShadow="0 0 10px black"
                        fontSize={['22px', '22px', '22px', '35px']}
                        fontWeight="bold"
                      >
                        {item.name}
                      </Text>
                    </Box>

                    <Box marginTop="20px" overflow={['scroll', 'hidden', 'hidden']}>
                      <Text fontSize={['15px', '17px', '19px', '20px']} textAlign="justify">
                        <Container maxWidth={['100%', '100%', '90%']}>{item.disc}</Container>
                      </Text>
                    </Box>

                    <Box marginTop="20px" overflow={['scroll', 'hidden', 'hidden']}>
                      <Text
                        fontSize={['19px', '19px', '20px', '30px']}
                        as="b"
                        textDecoration="underline"
                        textShadow="0 0 10px orange"
                      >
                        TechStack
                      </Text>
                      <Box display="flex" fontSize={['17px', '19px', '21px', '24px']} textAlign="justify">
                        {item.techStack.map((s) => (
                          <Container maxWidth="-moz-fit-content" margin="5px" key={s}>
                            {s}
                          </Container>
                        ))}
                      </Box>
                    </Box>

                    <Box display="flex" justifyContent="space-between" marginTop="20px">
                      <motion.div whileHover={{ scale: 1.05 }}>
                        <Button
                          size="sm"
                          colorScheme="teal"
                          fontSize={['16px', '18px', '20px', '25px']}
                          as="a"
                          href={item.netlify}
                          target="_blank"
                          bg={'teal.500'}
                          _hover={{ bg:'teal.600' }}
                        >
                          Demo
                        </Button>
                      </motion.div>
                      <motion.div whileHover={{ scale: 1.05 }}>
                        <Button
                          size="sm"
                          colorScheme="blue"
                          fontSize={['16px', '18px', '20px', '25px']}
                          as="a"
                          href={item.github}
                          target="_blank"
                          bg={'blue.500'}
                          _hover={{ bg: 'blue.600' }}
                        >
                          Code
                        </Button>
                      </motion.div>
                    </Box>
                  </Box>
                </SimpleGrid>
              </Box>
            );
          })}
        </SimpleGrid>
      </motion.div>
      <Box py={10} />
    </>
  );
}

export default ProjectsP;
